{
  "translation": {
    "button": {
      "ok": "Ok",
      "back": "Back",
      "create": "Create",
      "logout": "Logout",
      "login": "Login",
      "cancel": "Cancel",
      "search": "Search",
      "configurations": "Configurations"
    },
    "label": {
      "configurationId": "Configuration Id",
      "id": "Id",
      "product": "Product",
      "productName": "Product Name",
      "productId": "Product Id",
      "timeStamp": "Created On",
      "modifiedOn": "Modified On",
      "validate": "Validate",
      "view": "View",
      "featureCode": "Feature Code",
      "optionCode": "Option Code",
      "productImages": "Product Images",
      "salesText": "Sales Text",
      "country": "Country",
      "createdOn": "Created On",
      "timeZone": " UTC",
      "inActiveProduct": "Product Inactive",
      "views": "Views",
      "confirm": "Confirm",
      "propertyCode": "Property Code",
      "oldValue": "Old Value",
      "newValue": "New Value",
      "properties": "Properties",
      "options": "Options",
      "noRows": "No Rows",
      "no": "No",
      "yes": "Yes"
    },
    "tooltip": {
      "validate": "Validate",
      "view": "View",
      "productInfo": "Product Info",
      "home": "Home",
      "valid": "Valid",
      "invalid": "Invalid",
      "added": "Added",
      "deleted": "Deleted",
      "modified": "Modified"
    },
    "actionTypes": {
      "created": "Created",
      "cloned": "Cloned",
      "search": "Searched",
      "validate": "Validated"
    },
    "pageErrors": {
      "noPageFound": "No Page Found.",
      "unauthenticated": "User is not logged in. Please login. If problem persists, please contact your administrator."
    },
    "message": {
      "logoutMessage": "User is logged out. Please login to the application again.",
      "viewChange": "Do you wish to Change the View to {{view}}?",
      "configurationExists": "Configuration already exists",
      "loading": "Loading...",
      "tempWarningMessage": "This configuration is deleted when closed.",
      "success": {
        "general": "Success:  ",
        "default": "Data retrived",
        "getUser": "User details retrieved",
        "searchConfiguration": "Configuration added",
        "getConfiguration": "Configuration retrieved"
      },
      "error": {
        "401": "Session expired. Please login again.",
        "403": "You dont have access. Please contact administrator.",
        "general": "Error:  ",
        "default": "Something went wrong.Try again",
        "getUser": "Unable to Load user",
        "searchConfiguration": "Add Configuration Failed",
        "getConfiguration": "Configuration",
        "getDiff": "Unable to load difference",
        "invalidConfiguration": "Invalid Configuration id"
      }
    },
    "title": {
      "name": "Configuration Validation Application"
    },
    "footer": {
      "env": "Env",
      "termsAndConditions": "Terms & Conditions",
      "release": "R",
      "sprint": "SP",
      "build": "Build",
      "branch": "Branch",
      "date": "Date"
    }
  }
}